import { useEffect } from 'react'

import { useAxiosHttpClient } from '@/modules/shared/infra/axios-http-client.infra'
import { HttpStatusCode } from '@/modules/shared/protocols/http-client.protocol'
import { useMainStore } from '@/modules/shared/stores/main.store'

import {
  type TClienteDeleteActionService,
  clienteDeleteActionService,
} from '../services/client-delete-action.service'
import { useCustomerFormStoreAction } from '../stores/customer-form.store'

export const useCustomerSearchData = () => {
  const { setCustomers } = useMainStore().actions
  const { setCustomerSelected } = useCustomerFormStoreAction

  const { axiosRequest: requestDeleteCustomer } = useAxiosHttpClient({
    sendRequest: clienteDeleteActionService,
  })

  const deleteCustomer = ({ payload }: TClienteDeleteActionService) => {
    requestDeleteCustomer.mutate({
      payload,
      showInfo: true,
      showSuccess: true,
    })
  }

  useEffect(() => {
    const { data, isSuccess } = requestDeleteCustomer

    if (isSuccess) {
      if (data.status === HttpStatusCode.OK) {
        setCustomers(undefined)
        setCustomerSelected(undefined)
      }
    }

    // eslint-disable-next-line
  }, [requestDeleteCustomer.isLoading])

  return {
    isLoadingDeleteCustomer: requestDeleteCustomer.isLoading,
    deleteCustomer,
  }
}
